module.exports = __webpack_public_path__ + "static/media/loc3_img9.d13f4715.jpg";